import { uploadRuleInfoXml, getRuleInfoByFileId, ruleInfoRequest, deleteRuleInfo, EditFileFromContent } from '@/network/requests/ruleInfo'
import seriousScrapped from '../SeriousScrapped'
import { jtCommandRequest } from '@/network/requests/jtCommand'
import _ from 'lodash'
export default {
	data() {
		/**
		 * 重名检查
		 * @param {*} rule
		 * @param {*} value
		 * @param {*} callback
		 */
		var checkNameExist = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入配置名称'))
			} else {
				let exist = undefined
				if (this.form.id) {
					exist = this.tableData.find(t => t.name == this.form.name && t._id.$oid != this.form.id)
				} else {
					exist = this.tableData.find(t => t.name == this.form.name)
				}
				if (exist) {
					callback(new Error('配置名称已存在，请更换配置名称。'))
				} else {
					callback()
				}
			}
		}

		return {
			ruleForms: [],
			tableLoading: false,
			tableData: [],
			name: '',
			dialog_visible_config: false,
			dialog_visible_save: false,
			config_fileId: '',
			loading: false,
			titleDialog: '',
			setColor: false,
			saving: false,
			form: {
				name: '',
				id: '',
				fileId: '',
			},
			formRules: {
				name: [
					{ validator: checkNameExist, trigger: 'blur' },
					{ required: true, message: '请输入规则名称', trigger: 'blur' },
					{ min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' },
				],
			},
		}
	},
	props: {
		file_id: {
			type: String,
		},
		jt_id: {
			type: String,
			required: true,
		},
	},
	watch: {
		/**
		 * 通过文件加载配置。
		 */
		file_id(val) {
			console.log('handle watch file_id', val)
			this.config_fileId = val
			this.setColor = false
		},
		/**
		 * 当前配置文件Id。
		 */
		config_fileId(val) {
			console.log('handle watch config_fileId', val)
			if (!val) {
				this.ruleForms = []
				return
			}
			this.getFileContent(val)
		},
	},
	computed: {
		continueRulesLength() {
			if (this.ruleForms.length == 0) return 0

			return this.ruleForms.filter(t => t.type == 'ContinueRules').length
		},
		densityRulesLength() {
			if (this.ruleForms.length == 0) return 0

			return this.ruleForms.filter(t => t.type == 'DensityRules').length
		},
		frequencyRulesLength() {
			if (this.ruleForms.length == 0) return 0

			return this.ruleForms.filter(t => t.type == 'FrequencyRules').length
		},
		/**
		 * 配置名称。
		 */
		configName() {
			if (this.config_fileId) {
				var td = this.tableData.find(t => t.rule_info_file_id == this.config_fileId)
				if (td) return td.name

				return ''
			}
			return '未配置'
		},
	},
	methods: {
		/**
		 * 下发配置。
		 */
		distribution() {
			var cmd = 2
			jtCommandRequest
				.upload({
					jt_id: this.jt_id,
					cmd: cmd,
					is_set_cmd: 1,
					command_file_id: this.config_fileId,
					time: { $date: new Date().getTime() },
				})
				.then(res => {
					this.$message({
						message: '命令下发成功。',
						type: 'success',
					})
				})
				.finally(() => {
					this.setColor = false
				})
		},
		/**
		 * 保存严重废规则名称。
		 */
		save() {
			this.$refs['saveForm'].validate(valid => {
				if (valid) {
					//相当于另存为新配置。
					if (!this.form.id) {
						this.handleSave()
						this.activeColor = false
					} else {
						//修改配置名称。
						this.changeConfig()
					}
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		/**
		 * 修改配置名称。
		 */
		changeConfig() {
			this.saving = true
			EditFileFromContent(this.form.id, this.form.name)
				.then(res => {
					this.$message({
						message: '名称修改成功',
						type: 'success',
					})
				})
				.catch(err => {
					this.$message.error('错误：' + err)
				})
				.finally(() => {
					this.dialog_visible_save = false
					this.loadRules()
					this.saving = false
				})
		},
		/**
		 * 编辑名称
		 * @param {*} row
		 */
		handleEditConfig(row) {
			this.titleDialog = '编辑名称'
			this.dialog_visible_save = true
			this.form = {
				name: row.name,
				id: row._id.$oid,
				fileId: row.rule_info_file_id,
			}
		},
		/**
		 * 加载所有配置。
		 */
		loadRules() {
			this.tableLoading = true
			ruleInfoRequest
				.queryAll(undefined, undefined, { _id: -1 })
				.then(res => {
					this.tableData = res
				})
				.finally(() => {
					this.tableLoading = false
				})
		},
		/**
		 * 获取配置内容。
		 * @param {*} file_id
		 */
		getFileContent(file_id) {
			this.loading = true
			ruleInfoRequest
				.getFileContentById(file_id)
				.then(res => {
					try {
						this.ruleForms = seriousScrapped.getRuleInfoFromXml(res.data)
					} catch (error) {
						this.ruleForms = []
					}
				})
				.catch(err => {
					var msg = err
					if (err.toString().indexOf('404') > -1) {
						msg = '文件未找到'
					}
					this.$message.error(msg)
					this.ruleForms = []
				})
				.finally(() => {
					this.dialog_visible_config = false
					this.loading = false
				})
		},
		/**
		 * 添加规则。
		 * @param {*} ruleType
		 * @param {*} title
		 */
		addRule(ruleType, title) {
			var temp = {
				title: title,
				type: ruleType,
				length: 1,
				defectNumber: 1,
				defectNumberMin: 10,
			}

			//连续废和频次废的默认最小值=10。
			if (ruleType != 'ContinueRules') {
				temp.defectNumber = 10
				temp.length = 10
			}

			//频次废需要添加属性：AreaSegmentationSize
			if (ruleType == 'FrequencyRules') {
				temp.areaSegmentationSize = 1
			}

			var index = _.findLastIndex(this.ruleForms, t => t.type == ruleType)
			if (index == -1) {
				this.ruleForms.push(temp)
			} else {
				this.ruleForms.splice(index + 1, 0, temp)
			}
		},
		/**
		 * 删除规则。
		 * @param {*} item
		 * @param {*} index
		 */
		removeRule(item, index) {
			this.ruleForms.splice(index, 1)
		},
		/**
		 * 添加命令。
		 * @param {*} command
		 */
		handleCommand(command) {
			if (command == 'addRule1') {
				this.addRule('ContinueRules', '连续废')
			} else if (command == 'addRule2') {
				this.addRule('DensityRules', '密度废')
			} else if (command == 'addRule3') {
				this.addRule('FrequencyRules', '频次废')
			}
		},
		/**
		 * 另存为配置。
		 */
		saveAs() {
			this.form.name = ''
			this.form.id = ''
			this.form.fileId = ''
			this.titleDialog = '配置名称'
			this.dialog_visible_save = true
		},
		/**
		 * 修改配置。
		 */
		updateRule() {
			var xml = seriousScrapped.saveRuleInfo(this.jt_id, this.ruleForms)

			//保存严重废规则。
			uploadRuleInfoXml(xml, this.form.name, this.jt_id, this.config_fileId)
				.then(res => {
					this.$message({
						message: '配置修改成功。',
						type: 'success',
					})
				})
				.catch(err => {
					this.$message.error('错误：' + err)
				})
		},
		/**
		 * 选择已有配置。
		 */
		selectConfig() {
			this.dialog_visible_config = true
		},
		/**
		 * 保存配置。
		 */
		handleSave() {
			this.saving = true
			//获取严重废规则XML内容。
			var xml = seriousScrapped.saveRuleInfo(this.jt_id, this.ruleForms)

			//保存严重废规则。
			uploadRuleInfoXml(xml, this.form.name, this.jt_id)
				.then(res => {
					this.$message({
						message: '严重废规则保存成功',
						type: 'success',
					})

					this.config_fileId = res.rule_info_file_id
				})
				.catch(err => {
					this.$message.error('错误：' + err)
				})
				.finally(() => {
					this.loadRules()
					this.dialog_visible_save = false
					this.saving = false
				})
		},
		/**
		 * 使用配置。
		 */
		handleSelectConfig(row) {
			this.config_fileId = row.rule_info_file_id
			this.setColor = true
			this.dialog_visible_config = false
		},
		/**
		 * 查看配置内容。
		 */
		handleViewContent() {},
		/**
		 * 删除配置。
		 * @param {*} row
		 */
		handleDeleteConfig(row) {
			//需要删除记录和文件。
			deleteRuleInfo(row._id.$oid, row.rule_info_file_id).then(res => {
				console.log('删除配置', res)
				//重新加载严重废规则。
				this.loadRules()
			})
		},
	},
	created() {
		//加载已有的严重废规则。
		this.loadRules()
		this.config_fileId = this.file_id
	},
}
